import { Input } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
function NativeInput(props) {
    const { nativeProps = {}, readonly, color, ...restProps } = props;
    const { className: nativeClassname, ...restNativeProps } = nativeProps;
    return (React.createElement(Input, { nativeProps: {
            className: classNames(prefixClassname("native-input"), {
                [prefixClassname("native-input--readonly")]: readonly,
                [prefixClassname("native-input--colorful")]: color || readonly,
            }, nativeClassname),
            readonly,
            ...restNativeProps,
        }, ...restProps }));
}
export default NativeInput;
